import { configureStore } from '@reduxjs/toolkit'
import campaignConfigReducer from 'features/campaignConfig/campaignConfigSlice';
import partiesReducer from 'features/parties/partiesSlice';
import partyOrderReducer from 'features/parties/partyOrderSlice';
import responsiveViewReducer from 'features/responsive/responsiveSlice';
import regionReducer from 'features/region/regionSlice';

export const store = configureStore({
  reducer: {
    campaignConfig: campaignConfigReducer,
    parties: partiesReducer,
    partyOrder: partyOrderReducer,
    responsiveView: responsiveViewReducer,
    region: regionReducer
  },
})